import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { t } from '@framework/i18n';

/**
 * Ellipsis con icona
 */
export function ellipsisExpandIconSymbol(expanded: boolean) {
  return expanded ? ( // NOSONAR
    <MinusOutlined aria-label={t('ui.ellipsis.collapse', 'contrai')} />
  ) : (
    <PlusOutlined aria-label={t('ui.ellipsis.expand', 'espandi')} />
  );
}

/**
 * Ellipsis con testo
 */
export function ellipsisExpandTextSymbol(expanded: boolean) {
  return expanded // NOSONAR
    ? t('ui.ellipsis.collapse', 'contrai')
    : t('ui.ellipsis.expand', 'espandi');
}
